// extracted by mini-css-extract-plugin
export default {"date":"x4E2EU","eventList":"yOdi57","dateText":"qdGGIq","eventDetails":"n0wLQ6","dateWithChevron":"gopCkY","dateChevron":"VL0NNk","close":"s2gxRe"};